import React from "react";
import {Pane} from "evergreen-ui";
import {useSelector} from "react-redux";

export default function RiverFloodSpringTable() {

    const tableStyle = {
        tableLayout: "fixed",
        width: "1600px",
        borderCollapse: "collapse",
        marginBottom: "90px",
        fontFamily: "\"SF UI Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
    }

    const constructor = useSelector(state => state.riverFloodConstructor);
    const filtersRows = constructor.filters;

    const createTable = () => {

        return (
            <table border={"1px"} style={tableStyle}>
                <tr>
                    <th width={250} rowSpan={2}>Наименование источника</th>
                    <th colSpan={3}>Период половодья</th>
                    <th rowSpan={2}>Слой стока за половодье, мм</th>
                    <th colSpan={2}>Запас воды в снеге и ледяной корке перед началом снеготаяния</th>
                    <th rowSpan={2}>Осадки за период от даты снегосъемки до конца половодья, мм</th>
                    <th rowSpan={2}>Общий запас воды, мм</th>
                    <th rowSpan={2}>Коэффициент стока</th>
                    <th colSpan={2}>Максимальный модуль весеннего стока</th>
                </tr>
                <tr>
                    <th>начало</th>
                    <th>конец</th>
                    <th>продол-ть, сут</th>
                    <th>дата</th>
                    <th>мм</th>
                    <th>дата</th>
                    <th>Модуль, л/с*км2</th>
                </tr>
                {filtersRows.map(filter =>
                    <tr>
                        <td width={250} height={20}>{filter.rainfall.type.name}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )}
            </table>
        );
    }



    return (
        <>
            <Pane marginTop={30}><h3>Характеристика стока за период весеннего половодья</h3></Pane>
            <Pane marginTop={30} width={1600}>
                {createTable()}
            </Pane>
        </>
    )
}